import { alpha } from "@mui/material/styles";

import { useDynamicThemeAwareVariables } from "@/common/hooks/useDynamicThemeAwareVariables";

const LIGHT_MODE_SECONDARY_TEXT_OPACITY = 0.7;

export const useSecondaryTextColor = (): string =>
  useDynamicThemeAwareVariables(({ formsPalette, mode }) =>
    mode === "light" ? alpha(formsPalette.text.moderate, LIGHT_MODE_SECONDARY_TEXT_OPACITY) : formsPalette.text.supershy
  );
